import enUi from './en/ui.json';
import enReviews from './en/reviews.json';
import enTeachers from './en/teachers.json';
import enPlatform from './en/platform.json';
import enCourses from './en/courses.json';
import bnUi from './bn/ui.json';
import bnReviews from './bn/reviews.json';
import bnTeachers from './bn/teachers.json';
import bnPlatform from './bn/platform.json';
import bnCourses from './bn/courses.json';

// Text for each language. Language-neutral data (payment numbers, batches)
// lives in payment.json and batches.json.
const content = {
  en: { ui: enUi, reviews: enReviews, teachers: enTeachers, platform: enPlatform, courses: enCourses },
  bn: { ui: bnUi, reviews: bnReviews, teachers: bnTeachers, platform: bnPlatform, courses: bnCourses },
};

export default content;
